/**
 * @generated SignedSource<<a25809bfd615db6328592a9a4f4d1fdd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppBreadcrumbs_repository$data = {
  readonly id: string;
  readonly name: string;
  readonly owner: string;
  readonly platform: string;
  readonly " $fragmentType": "AppBreadcrumbs_repository";
};
export type AppBreadcrumbs_repository$key = {
  readonly " $data"?: AppBreadcrumbs_repository$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppBreadcrumbs_repository">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppBreadcrumbs_repository",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "742ded03710185cd90fe04769a16aea0";

export default node;
